// ink-component
import React, { useContext } from 'react';
import { Icon } from '../../../Icon/Icon';
import { SideNavContext } from '../../SideNavContext';
import getGlobalProps from '../../../../helpers/constants/global-props';
import { StyledSideNavToggle } from './styles';

export type SideNavToggleProps = {
  /** onClick callback, sends the event */
  onClick?: () => void;
  /** Marks the element with a given ID to make it easier to select it on tests */
  'data-testid'?: string | number;
};

/**
 * @purpose Element for toggling side navigation open and closed state
 * @group SideNav
 * @categories navigation
 */
const SideNavToggle = ({ onClick, 'data-testid': dataTestId }: SideNavToggleProps) => {
  const { isClosed, toggleClosed } = useContext(SideNavContext);
  const globalProps = getGlobalProps({});

  const handleClick = () => {
    toggleClosed();
    onClick?.();
  };

  return (
    <StyledSideNavToggle onClick={handleClick} {...globalProps} data-testid={dataTestId}>
      <Icon
        size="lg"
        placement="low"
        type={isClosed ? 'hamburger' : 'hamburger-collapse'}
        meaning={isClosed ? 'Open menu' : 'Close menu'}
      />
    </StyledSideNavToggle>
  );
};

SideNavToggle.displayName = 'SideNav.Toggle';

export default SideNavToggle;
